import React, { useState, useEffect } from 'react';
import './TextQuestion.css';


// API URL will be constructed dynamically based on props

// esse ficou estranho o texto no latex
// R$ 150,00, e, quando compra 5, o custo sobe para R$ 250,00\ está considerando o $ como identificador de latex: NAO PODE!!!!
//const API_URL = 'https://rvensino.com.br/get.php?action=get_question2&question_id=762';

//const API_URL = 'https://rvensino.com.br/get.php?action=get_question2&question_id=763';

//const API_URL = 'https://rvensino.com.br/get.php?action=get_question2&question_id=764';

// tudo em itálico: NAO pode!!!!
//const API_URL = 'https://rvensino.com.br/get.php?action=get_question2&question_id=757';

//const API_URL = 'https://rvensino.com.br/get.php?action=get_question2&question_id=964';

// N2O4(g) ⇌ 2 NO2(g) 
// N<subscrito>2</subscrito>O<subscrito>4</subscrito>
//const API_URL = 'https://rvensino.com.br/get.php?action=get_question2&question_id=1038';

//const API_URL = 'https://rvensino.com.br/get.php?action=get_question2&question_id=1059';

//const API_URL = 'https://rvensino.com.br/get.php?action=get_question2&question_id=1276';

//const API_URL = 'https://rvensino.com.br/get.php?action=get_question2&question_id=1331';

// Função para processar LaTeX
const processLatex = (text) => {
    if (!text) return '';
    
    // Substitui <latex-bloco> por $$ para display math
    let processedText = text.replace(/<latex-bloco>/g, '$$');
    processedText = processedText.replace(/<\/latex-bloco>/g, '$$');
    
    // Substitui \\ por \\\\ para quebras de linha no LaTeX
    processedText = processedText.replace(/\\\\/g, '\\\\\\\\');
    
    // Substitui <negrito> e <italico> por tags HTML
    processedText = processedText.replace(/<negrito>/g, '<b>');
    processedText = processedText.replace(/<\/negrito>/g, '</b>');
    processedText = processedText.replace(/<italico>/g, '<i>');
    processedText = processedText.replace(/<\/italico>/g, '</i>');
    
    return processedText;
};

// Função para renderizar texto com LaTeX
const renderTextWithLatex = (text) => {
    const processedText = processLatex(text);
    
    // Se não há LaTeX, retorna o texto normal
    if (!processedText.includes('$$')) {
        return <div dangerouslySetInnerHTML={{ __html: processedText.replace(/\n/g, '<br/>') }} />;
    }
    
    // Divide o texto em partes (LaTeX e texto normal)
    const parts = processedText.split(/(\$\$.*?\$\$)/g);
    
    return parts.map((part, index) => {
        if (part.startsWith('$$') && part.endsWith('$$')) {
            // Remove os $$ e renderiza como LaTeX
            const latexContent = part.slice(2, -2);
            return (
                <div key={index} className="latex-equation" style={{
                    textAlign: 'center',
                    margin: '10px 0',
                    padding: '10px',
                    backgroundColor: '#f8f9fa',
                    borderRadius: '4px',
                    border: '1px solid #e9ecef'
                }}>
                    <span className="latex-content">{latexContent}</span>
                </div>
            );
        } else {
            // Texto normal
            return (
                <span key={index} dangerouslySetInnerHTML={{ 
                    __html: part.replace(/\n/g, '<br/>') 
                }} />
            );
        }
    });
};

const renderStatement = (statement) => {
    if (!statement) return null;
    return Object.entries(statement).map(([key, part]) => {
        switch (part.type) {
            case 'texto':
                return (
                    <div key={key} className="question-text-body" style={{marginBottom: 12}}>
                        {part.title && <div className="question-text-title" style={{fontWeight: 'bold', fontSize: '1.05rem'}}>{part.title}</div>}
                        {renderTextWithLatex(part.value)}
                        {part.reference && (
                            <div
                                className="question-text-reference"
                                dangerouslySetInnerHTML={{ __html: processLatex(part.reference) }}
                            />
                        )}
                    </div>
                );
            case 'imagem':
            case 'tabela':
                return (
                    <div key={key} className="question-text-image" style={{display: 'flex', flexDirection: 'column', alignItems: 'center', margin: '24px 0 12px 0'}}>
                        {part.title && <div className="question-text-title" style={{fontWeight: 'bold', fontSize: '1.05rem'}}>{part.title}</div>}
                        <img 
                            src={`https://rvensino.com.br/Question_images/${part.value}`} 
                            alt={part.title || 'Imagem da questão'}
                            style={{background: '#fff', padding: 8, maxWidth: '90%', margin: '0 auto'}}
                        />
                        {part.reference && (
                            <div
                                className="question-text-reference"
                                dangerouslySetInnerHTML={{ __html: processLatex(part.reference) }}
                            />
                        )}
                    </div>
                );
            case 'poema':
                return (
                    <div key={key} className="question-text-poem" style={{fontStyle: 'italic', margin: '0 2em', textAlign: 'left'}}>
                        {part.title && <div className="question-text-title" style={{fontWeight: 'bold', fontSize: '1.05rem'}}>{part.title}</div>}
                        <div style={{whiteSpace: 'pre-line'}}>{part.value}</div>
                        {part.reference && (
                            <div
                                className="question-text-reference"
                                dangerouslySetInnerHTML={{ __html: processLatex(part.reference) }}
                            />
                        )}
                    </div>
                );
            default:
                return null;
        }
    });
};

const TextQuestion = ({ questionNumber, questionAnswer, userAnswer, textData }) => {
    const [questionContent, setQuestionContent] = useState(null);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);

    useEffect(() => {
        if (textData) {
            setLoading(true);
            try {
                setQuestionContent({
                    title: `QUESTÃO ${questionNumber}`,
                    statement: textData.statement,
                    command: textData.command,
                    options: [
                        { letter: 'A', text: textData.alternatives.A },
                        { letter: 'B', text: textData.alternatives.B },
                        { letter: 'C', text: textData.alternatives.C },
                        { letter: 'D', text: textData.alternatives.D },
                        { letter: 'E', text: textData.alternatives.E }
                    ]
                });
                setError(null);
            } catch (err) {
                setError('Erro ao processar dados da questão');
            } finally {
                setLoading(false);
            }
        } else {
            setError('Questão em texto não disponível');
            setLoading(false);
        }
    }, [questionNumber, textData]);

    // Efeito para renderizar MathJax quando o conteúdo mudar
    useEffect(() => {
        if (questionContent && window.MathJax) {
            // Aguarda um pouco para garantir que o DOM foi atualizado
            const timer = setTimeout(() => {
                if (window.MathJax.typesetPromise) {
                    window.MathJax.typesetPromise();
                }
            }, 100);
            
            return () => clearTimeout(timer);
        }
    }, [questionContent]);

    if (loading) return <div className="question-loading">Carregando questão...</div>;
    if (error) return <div className="question-error">{error}</div>;
    if (!questionContent) return null;

    return (
        <div className="question-text-content">
            <div className="question-text-title">{questionContent.title}</div>
            {renderStatement(questionContent.statement)}
            {questionContent.command && (
                <div className="question-text-body" style={{marginBottom: 12}}>
                    {renderTextWithLatex(questionContent.command)}
                </div>
            )}
            <div className="question-text-options">
                {questionContent.options.map(option => {
                    const isCorrect = option.letter === questionAnswer;
                    const isSelected = option.letter === userAnswer;
                    let optionClass = 'question-text-option';
                    
                    // Sempre adiciona a classe para resposta correta
                    if (isCorrect) {
                        optionClass += ' correct-answer';
                    }
                    
                    // Adiciona classes para resposta selecionada pelo usuário
                    if (isSelected) {
                        optionClass += isCorrect ? ' correct-option' : ' incorrect-option';
                    }
                    
                    return (
                        <div key={option.letter} className={optionClass}>
                            <span className="option-letter">{option.letter}</span> {renderTextWithLatex(option.text)}
                        </div>
                    );
                })}
            </div>
        </div>
    );
};

export default TextQuestion; 